import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  model,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseFormControlComponent } from '../../../shared/components/base-form-control/base-form-control.component';
import { ValidityIconComponent } from '../../../shared/components/validity-icon/validity-icon.component';
import { FormControlDirective } from '../../../shared/directives/form-control/form-control.directive';

@Component({
  selector: 'app-form-email-input',
  templateUrl: './email-input.component.html',
  styleUrls: ['./email-input.component.scss'],
  providers: [
    {
      provide: BaseFormControlComponent,
      useExisting: forwardRef(() => EmailInputComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormControlDirective, ReactiveFormsModule, ValidityIconComponent],
  standalone: true,
})
export class EmailInputComponent extends BaseFormControlComponent<string> {
  autocomplete = input<string>('off');
  placeholder = model<string>('');
}
